import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../../reducers/authSlice';
import axios from 'axios';


import {
    Container, TextField, Box, Button, InputAdornment, IconButton, Grid, Typography,
    Paper, FormControl, Autocomplete, Dialog, DialogTitle, DialogContent, DialogActions,
    Divider
} from '@mui/material';
import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

const Usuarios = () => {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const err = useSelector((state) => state.auth.errors);
    const resData = useSelector((state) => state.auth.data);

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [company, setCompany] = useState('cronos');
    const [rol, setRol] = useState('');
    const [errors, setErrors] = useState({ name: '', email: '', password: '', password2: '', rol: '', company: '' });
    const [value, setValue] = useState(null); // Autocomplete

    const [modalDeleteUser, setModalDeleteUser] = useState(false);
    const [currentUser, setCurrentUser] = useState({});

    const [configs, setConfigs] = useState({});

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });
    const roles = ['Admin', 'Vendedor', 'Tecnico', 'Almacen', 'Secretaria', 'Ayudante', 'Distribuidor'];

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Usuarios';
    }, [auth])


    useEffect(() => {
        getData();
        getConfigs();
    }, [])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    const getConfigs = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/configs/company/${auth.user.company}`);
            if (res.status === 200) {
                setConfigs(res.data);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    // register user
    const getData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/users/`);
            if (res.status === 200) {
                let users = res.data;
                if (users.find(user => user.name === 'Jorge Benítez')) {
                    users = users.filter(user => user.name !== 'Jorge Benítez');
                    setData(users);
                    setLoading(false);
                } else {
                    setData(users);
                    setLoading(false);
                }

            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (err) {
            setErrors(err);
        }
    }, [err])

    const handleSubmit = e => {
        e.preventDefault();

        const userData = {
            name: name,
            email: email,
            password: password,
            password2: password2,
            company: configs.company,
            rol: rol
        };

        dispatch(registerUser(userData));
    }

    useEffect(() => {
        if (resData.email !== undefined && resData.email !== '') {
            setApiRes(state => { return { ...state, show: true, message: 'Usuario agregado', severity: 'success' } });
            setName('');
            setEmail('');
            setPassword('');
            setPassword2('');
            setRol('');
            setValue(null);
            setErrors({ name: '', email: '', password: '', password2: '', rol: '', company: '' });
            getData();
        }
    }, [resData])

    // render users
    const renderUsers = () => {
        if (data.length > 0) {
            return (
                <div>
                    <Grid container spacing={1} className='my-1' sx={{ border: '0.5px solid #ccc', borderRadius: '20px', padding: '10px 4px' }}>
                        <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography fontWeight={700}>Nombre</Typography>
                        </Grid>
                        <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography fontWeight={700}>eMail</Typography>
                        </Grid>
                        <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography fontWeight={700}>Rol</Typography>
                        </Grid>
                        <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography fontWeight={700}></Typography>
                        </Grid>
                    </Grid>
                    {data.map((n, i) => (
                        <Grid container spacing={1} key={data[i]._id} className='my-1' sx={{ border: '0.5px solid #ddd', borderRadius: '20px', padding: '10px 4px' }}>
                            <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography fontWeight={700}>{data[i].name}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography sx={{ textAlign: 'center' }}>{data[i].email}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Typography>{data[i].rol}</Typography>
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <FormControl style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Button variant='outlined' color='error' onClick={() => handleBeforeDeleteUser(data[i])}>Eliminar &nbsp;<i className='fa fa-trash-alt'></i>&nbsp;</Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    ))}
                </div>
            )
        } else { return null }
    }

    const handleBeforeDeleteUser = (d) => {
        setCurrentUser(d);
        setModalDeleteUser(true);
    }

    const handleDeleteUser = async (d) => {
        const res = await axios.delete(`/api/users/${d}`);
        if (res.status === 200) {
            getData();
            setApiRes({ show: true, message: 'Usuario eliminado', severity: 'success' });
        } else {
            setApiRes({ show: true, message: 'Error al eliminar el usuario', severity: 'error' });
        }
        handleCloseDeleteUser();
    }

    const handleCloseDeleteUser = () => {
        setModalDeleteUser(false);
        setCurrentUser({ name: '', email: '', rol });
    }

    const renderDeleteUser = () => {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={modalDeleteUser}
                scroll='paper'
                onClose={handleCloseDeleteUser}>
                <DialogTitle >Eliminar Categoría</DialogTitle>
                <DialogContent>
                    <Typography variant='body1' sx={{ mb: 2 }}>¿Está seguro de eliminar al usuario?</Typography>
                    <Typography variant='body1'>Nombre: <span style={{ fontWeight: 700 }}> {currentUser.name}</span></Typography>
                    <Typography variant='body1'>eMail: <span style={{ fontWeight: 700 }}>{currentUser.email}</span></Typography>
                    <Typography variant='body1'>Rol: <span style={{ fontWeight: 700 }}>{currentUser.rol}</span></Typography>
                    <Button variant='contained' disabled={loading} color='error' onClick={() => handleDeleteUser(currentUser._id)} style={{ marginTop: '24px' }}>Eliminar &nbsp; <i className="fad fa-delete"></i></Button>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseDeleteUser()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>
                <Container maxWidth='xxl'>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Gestión de Usuarios</Typography>
                    </Box>
                    <Container maxWidth='xl'>
                        <Button size='small' variant='outlined' onClick={() => navigate('/config')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>
                    </Container>

                    <Divider className='my-3' textAlign="center">
                        <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Agregar nuevo usuario' className='text-bold' />
                    </Divider>

                    <Container style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '24px' }}>
                        <Box
                            component="form"
                            noValidate
                            autoComplete="off"
                            onSubmit={handleSubmit}
                        >
                            <Grid container maxWidth="sm" spacing={{ xs: 2, md: 3 }}>
                                <Grid item display="grid" xs={12} >
                                    <TextField
                                        error={errors.name ? true : false}
                                        variant="outlined"
                                        id="name"
                                        type={'text'}
                                        onChange={(e) => setName(e.target.value)}
                                        value={name}
                                        label="Nombre"
                                        helperText={`${errors.name === undefined ? '' : errors.name}`}
                                    />
                                </Grid>
                                <Grid item display="grid" xs={12} >
                                    <TextField
                                        error={errors.email ? true : false || errors.emailnotfound ? true : false}
                                        variant="outlined"
                                        id="email"
                                        type={'email'}
                                        onChange={(e) => setEmail(e.target.value)}
                                        value={email}
                                        label="Correo electrónico"
                                        helperText={`${errors.email === undefined ? '' : errors.email}` || `${errors.emailnotfound === undefined ? '' : errors.emailnotfound}`}
                                    />
                                </Grid>
                                <Grid item display="grid" xs={12}>
                                    <TextField
                                        error={errors.password ? true : false || errors.passwordincorrect ? true : false}
                                        id="password"
                                        label="Contraseña"
                                        type={'password'}
                                        onChange={(e) => setPassword(e.target.value)}
                                        value={password}
                                        helperText={`${errors.password === undefined ? '' : errors.password}` || `${errors.passwordincorrect === undefined ? '' : errors.passwordincorrect}`}
                                    />
                                </Grid>
                                <Grid item display="grid" xs={12}>
                                    <TextField
                                        error={errors.password2 ? true : false}
                                        id="password2"
                                        label="Confirmar contraseña"
                                        type={'password'}
                                        onChange={(e) => setPassword2(e.target.value)}
                                        value={password2}
                                        helperText={`${errors.password2 === undefined ? '' : errors.password2}`}
                                    />
                                </Grid>
                                <Grid item display="grid" xs={12} >
                                    <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                        <Autocomplete
                                            disablePortal
                                            freeSolo={false}
                                            onInputChange={(event, newInputValue) => setRol(newInputValue)}
                                            inputValue={rol}
                                            value={value}
                                            onChange={(event, newValue) => {
                                                setValue(newValue);
                                            }}
                                            defaultValue={'Vendedor'}
                                            options={roles}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    label='Rol del Usuario'
                                                    error={errors.rol ? true : false}
                                                    helperText={`${errors.rol === undefined ? '' : errors.rol}`}
                                                />}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                                    <Button type='submit' size="large" variant="contained" color={"secondary"}>Registrar usuario &nbsp; <i className="fad fa-sign-in"></i></Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                    <Container>
                        <Divider className='my-5' textAlign="center">
                            <CustomChip variant='outlined' estatus='DIAGNOSTICADO' label='Lista de Usuarios' className='text-bold' />
                        </Divider>
                        {renderUsers()}
                    </Container>
                </Container>
            </Paper>

            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            {renderDeleteUser()}
        </Container>
    )
}

export default Usuarios;